/* Maison Atlas : code de réduction dans le panier (tiroir et page). Délégation d'événements : le pied de panier est re-rendu en AJAX.
   Un code refusé ne fait pas perdre les codes déjà appliqués : ils sont reposés. */
(() => {
  if (window.maCartReady) return;
  window.maCartReady = true;

  function refreshCart() {
    const lists = document.querySelectorAll('cart-items');
    if (!lists.length) {
      window.location.reload();
      return;
    }
    lists.forEach((el) => {
      if (typeof el.renderItems === 'function') el.renderItems();
    });
  }

  function showError(box) {
    const error = box.querySelector('[data-ma-cart-code-error]');
    if (!error) return;
    error.textContent = error.dataset.message;
    error.hidden = false;
  }

  function updateDiscount(value) {
    return fetch(`${window.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: value })
    });
  }

  async function apply(box) {
    const input = box.querySelector('[data-ma-cart-code-input]');
    const button = box.querySelector('[data-ma-cart-code-apply]');
    const error = box.querySelector('[data-ma-cart-code-error]');
    const code = (input.value || '').trim();
    if (!code) {
      input.focus();
      return;
    }
    if (error) error.hidden = true;
    button.disabled = true;
    let previous = [];
    try {
      const before = await fetch(`${window.routes.cart_url}.js`).then((r) => r.json());
      previous = (before.discount_codes || []).filter((d) => d.applicable).map((d) => d.code);
      const response = await updateDiscount([...previous, code].join(','));
      const cart = await response.json();
      const applied = (cart.discount_codes || []).some((d) => d.code.toLowerCase() === code.toLowerCase() && d.applicable);
      if (!response.ok || !applied) {
        await updateDiscount(previous.join(','));
        showError(box);
        return;
      }
      refreshCart();
    } catch (e) {
      showError(box);
    } finally {
      button.disabled = false;
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ma-cart-code-apply]');
    if (!button) return;
    event.preventDefault();
    apply(button.closest('[data-ma-cart-code]'));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    const input = event.target.closest('[data-ma-cart-code-input]');
    if (!input) return;
    event.preventDefault();
    apply(input.closest('[data-ma-cart-code]'));
  });
})();